import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  UnarmedStrikesFeature,
  UpgradableNumber,
} from "@dndModels";
import { ABILITY_SCORES_EXPANDED, DAMAGE_TYPES } from "@dndModels/Constants";
import { DamageType } from "@dndModels/Types";

import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props { 
  obj: UnarmedStrikesFeature;
  disabled?: boolean;
  attached_table?: AttachedTable;
  onChange: (changed: UnarmedStrikesFeature) => void;
}

export default function UnarmedStrikesFeatureInput({ 
  obj,
  onChange,
  disabled = false,
  attached_table
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [myObj, setMyObj] = useState(obj.clone());
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  console.log(obj);
  console.log(myObj);
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 4
        }}>
        <ToggleButtonBox 
          name="Bonus Action Unarmed Strikes" 
          value={myObj.bonus_action_attack} 
          disabled={disabled}
          onToggle={() => {
            const new_obj = myObj;
            new_obj.bonus_action_attack = !new_obj.bonus_action_attack;
            setMyObj(new_obj);
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 4
        }}>
        <SelectStringBox 
          name="Attack Modifier" 
          options={ABILITY_SCORES_EXPANDED}
          value={myObj.use_ability_score} 
          disabled={disabled}
          onChange={(value: string) => {
            const new_obj = myObj as UnarmedStrikesFeature;
            new_obj.use_ability_score = value;
            setMyObj(new_obj);
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 4
        }}>
        <ToggleButtonBox 
          name="Add Attack Modifier to Damage" 
          value={myObj.add_attack_mod} 
          disabled={disabled}
          onToggle={() => {
            const new_obj = myObj as UnarmedStrikesFeature;
            new_obj.add_attack_mod = !new_obj.add_attack_mod;
            setMyObj(new_obj);
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox 
          name="Damage Types" 
          options={DAMAGE_TYPES}
          values={myObj.dts} 
          disabled={disabled}
          onChange={(changed: DamageType[]) => {
            const new_obj = myObj as UnarmedStrikesFeature;
            new_obj.dts = changed;
            setMyObj(new_obj);
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <UpgradableNumberBox 
          name="Damage Dice Count"
          value={myObj.damage_rolls.count.clone()} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(value: UpgradableNumber) => {
            const new_obj = myObj as UnarmedStrikesFeature;
            new_obj.damage_rolls.count = value.clone();
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <UpgradableNumberBox 
          name="Damage Dice Size"
          value={myObj.damage_rolls.size.clone()} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(value: UpgradableNumber) => {
            const new_obj = myObj as UnarmedStrikesFeature;
            new_obj.damage_rolls.size = value.clone();
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
    </Grid>
  );
}
